<template>
  <div class="divide-y-2 actions">
    <span class="spinner-border spinner-border-sm me-2" v-if="isLoad()"></span>
    <template v-else>
      <template v-if="!hasItems()">
        <p>Данных пока нет</p>
      </template>
      <template v-else>
        <div :key="data.getDatetime(item)" v-for="item in items">
          <div v-html="data.getDatetime(item)"></div>
          <img alt="" class="user-avatar" width="20" :src="data.getUserAvatar(item, 40)"> <b>{{ data.getUserName(item) }}</b> - {{ data.getActionName(item) }}
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import {defineComponent, onMounted, ref} from "vue"
import Api from "./services/Api"
import element from "./services/element"
import Image from "@/services/Image"
import DTBackend from "@/services/DTBackend"
import Helper from "@/services/Helper";

export default defineComponent({
  name: "Actions",
  props: {
    postId: {
      type: Number,
      required: true,
    },
    channelId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    let load = ref(true)
    let items = ref([])

    onMounted(() => {
      Api.actions(props.postId).then((resp) => {
        setItems(resp)
        startLoad()
      }).finally(() => {
        stopLoad()
      })
    })

    function setItems(val) {
      items.value = val
    }

    function startLoad() {
      load.value = true
    }

    function stopLoad() {
      load.value = false
    }

    function isLoad() {
      return load.value === true
    }

    function hasItems() {
      return items.value.length > 0
    }

    let data = {
      getUserName: (item) => {
        return element.getUserName(item)
      },

      getUserAvatar: (item, w) => {
        let host = element.getUserAvatarHost(item)
        let name = element.getUserAvatarName(item)

        if (host && name) {
            return Image.handle(host, name, w)
        }
        return "/assets/static/user/no_image.jpg"
      },

      getDatetime: (item) => {
        let datetime = element.getDatetime(item)
        let dt = new DTBackend(datetime)
        return dt.get("%D.%M.%y <span>%H:%I</span>")
      },

      getActionName: (item) => {
        let type = element.getType(item)
        let name = ""

        switch (type) {
          case 1:
            if (isChannelSite()) {
              name = "Выключен"
            } else if (isChannelTelegram()) {
              name = "Удален"
            } else {
              name = "-"
            }
            break;

          case 2:
            name = "Опубликован"
            break;

          case 3:
            name = "Отредактирован"
            break;

          case 4:
            name = "Создан черновик"
            break;

          case 5:
            name = "Просмотрен в боте"
            break;

          case 6:
            if (isChannelSite()) {
              name = "Выключен по расписанию"
            } else if (isChannelTelegram()) {
              name = "Удален по расписанию"
            } else {
              name = "-"
            }
            break;

          case 7:
            name = "Опубликован по расписанию"
            break;

          case 8:
            if (isChannelSite()) {
              name = "Выключен в удаленном посте"
            } else if (isChannelTelegram()) {
              name = "Отредактирован в удаленном посте"
            } else {
              name = "-"
            }
            break;

          case 9:
            name = "Повторно опубликован"
            break;

          case 10:
            if (isChannelSite()) {
              name = "Повторно выключен"
            } else if (isChannelTelegram()) {
              name = "Повторно удален"
            } else {
              name = "-"
            }
            break;

          case 11:
            name = "Повторно полностью удален"
            break;

          case 12:
            name = "Удален полностью"
            break;

          case 13:
            name = "Включен"
            break;

          case 14:
            if (isChannelSite()) {
              name = "Выключен автоматически по дате окончания"
            } else {
              name = "-"
            }
            break;

          default:
            break;
        }

        return name;
      },
    }

    function isChannelSite() {
      return Helper.inArray([props.channelId], [1])
    }

    function isChannelTelegram() {
      return Helper.inArray([props.channelId], [2,3,4,5,6,7,8,9,10,11,12])
    }

    return {
      isLoad,
      items,
      data,
      hasItems,
    }
  },
})
</script>

<style scoped></style>
